export const RACE_MAPPING: Record<string, string> = {
  'white': 'white',
  'black': 'black',
  'asian': 'asian'
};

export const SCALE_VALUE_PRIORITY: Record<string, number> = {
  'A': -4,
  'R': -5,
  'GL': -3.5,
  'G': -3,
  'GREY': -1
};

export const DEFAULT_SUBJECT_ID = 1008;
export const DEBUG_MODE = false;

export const STORAGE_KEYS = {
  BIOMARKERS_DATA: 'biomarkers_data',
  UPLOADED_FILE_INFO: 'uploaded_file_info'
} as const;
